/**
 * Created by Arison on 2019/7/9.
 */
import React from 'react';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/css/bootstrap.min.css'
/**
 * Created by Arison on 19:56.
 * 充值- 使用说明
 */
class RechargeIntroduce extends React.Component{
    constructor(props){
        super(props);
        this.state={
            name:'RechargeIntroduce'
        };
    }


    componentDidMount(){
        document.title = '充值消费说明'
    }

    render(){
        return <div className="padding_15">
            <div className="color_red span_18 text_bold">关于公众号充值消费说明！</div>
            <div className="text_bold span_17"> &nbsp;&nbsp;&nbsp;1.公众号充值消费是提供给家长便捷充值入口。</div>
            <div className="text_bold span_17"> &nbsp;&nbsp;&nbsp;2.充值金额最小单位为0.01元。</div>
            <div className="text_bold span_17"> &nbsp;&nbsp;&nbsp;3.充值完成后，持卡人需要到学校领款机或圈存设备进行领款，领款完成后充值金额才会到校园卡中。</div>
            <div className="text_bold span_17"> &nbsp;&nbsp;&nbsp;4.微信充值后五分钟内金额传递到消费卡饭卡。</div>
            <div className="text_bold span_17"> &nbsp;&nbsp;&nbsp;5.圈存完成后，系统会有微信消息通知给到家长。</div>
            <div className="text_bold span_17"> &nbsp;&nbsp;&nbsp;6.售后服务电话 蒋师：<a href={'tel:' + 17746845773} onClick={this.onPhoneClick}>17746845773</a>。</div>
        </div>
    }

    onPhoneClick = () => {
        // console.log("alert",this.alertClose)
        this.alertClose.close()
    }
}

export  default RechargeIntroduce;